import { TextTooltip } from 'components/common'
import * as React from 'react'
import Switch from 'react-switch'
import { lang } from 'utils/helpers'

const ToggleSwitch = ({ switchWidth, switchHeight, switchColor, switchHandleColor, checked, name, switchTitle, switchSubtitle, onChange, successMessage, errorMessage }) => {
  const [tooltipIsVisible, setTooltipIsVisible] = React.useState(false)

  React.useEffect(() => {
    if (successMessage || errorMessage) {
      setTooltipIsVisible(true)
      setTimeout(() => {
        setTooltipIsVisible(false)
      }, 2000)
    }
  }, [successMessage, errorMessage])

  return (
    <div className='toggle-switch'>
      <div className='switch-container'>
        <Switch
          onChange={value => onChange({ name, value })}
          checked={checked}
          onColor={switchColor || '#dd601d'}
          uncheckedIcon={false}
          checkedIcon={false}
          onHandleColor={switchHandleColor || '#FFFFFF'}
          width={switchWidth || 36}
          height={switchHeight || 18}
        />
      </div>
      <div className='title-container'>
        <p className='switch-title'>{switchTitle}</p>
        {switchSubtitle ? (
          <p className='switch-subtitle'>{switchSubtitle}</p>
        ) : null}
      </div>
      {tooltipIsVisible ? (
        <TextTooltip
          text={successMessage
            ? lang('dashboard_saved')
            : errorMessage
              ? 'Error'
              : ''
          }
          textColor={successMessage
            ? '#008100'
            : errorMessage
              ? '#DD3953'
              : ''
          }
        />
      ) : null}
    </div>
  )
}

export default ToggleSwitch
